import { render } from "./Tagging.vue?vue&type=template&id=6b970c10"
import script from "./Tagging.vue?vue&type=script&lang=js"
export * from "./Tagging.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__